import React, { useEffect, useState } from 'react';
import Datatable from '../../components/Datatable';
import { Box, Typography } from '@mui/material';
import moment from 'moment';
import BackupViewButton from '../../components/BackupView';

// Coluna combinada do Host (nome + IP + vendor — tipo). Padrão alinhado
// com Host.js e Queue.js — reduz "ruído de colunas" no cliente.
function HostCell({ name, ip, vendor, type }) {
    return (
        <Box>
            <Typography variant="body2" fontWeight={600}>{name}</Typography>
            <Typography variant="caption" color="text.secondary" display="block">{ip}</Typography>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.68rem' }}>
                {vendor} — {type}
            </Typography>
        </Box>
    );
}

export default function Backup() {
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        document.title = 'IPV7 Hermes - Backup';
    }, []);

    return (
        <Datatable
            refresh={refresh}
            handlerRefresh={() => setRefresh(!refresh)}
            title="Backups"
            endpoint="/hermes/backup"
            options={{
                customToolbar: () => null,
                customToolbarSelect: () => '',
            }}
            columns={[
                { name: 'id', label: 'ID', options: { display: false, filter: false, sort: false } },
                { name: 'ip', label: 'IP', options: { display: false } },
                { name: 'vendor_name', label: 'Marca', options: { display: false } },
                { name: 'type_name', label: 'Tipo', options: { display: false } },
                {
                    name: 'host_name', label: 'Host',
                    options: {
                        customBodyRender: (value, tableMeta) => (
                            // 0=id, 1=ip, 2=vendor, 3=type, 4=host_name
                            <HostCell name={value} ip={tableMeta.rowData[1]}
                                      vendor={tableMeta.rowData[2]} type={tableMeta.rowData[3]} />
                        ),
                    },
                },
                {
                    name: 'created_at', label: 'Último backup',
                    options: {
                        customBodyRender: (v) => (
                            <span>{moment(v).locale('pt-br').format('DD/MM/YYYY HH:mm:ss')}</span>
                        ),
                    },
                },
                {
                    name: 'actions', label: 'Ações',
                    options: {
                        filter: false, sort: false,
                        customBodyRender: (_, tableMeta) => (
                            <BackupViewButton id={tableMeta.rowData[0]} />
                        ),
                    },
                },
            ]}
        />
    );
}
